export const NotFound404 = () => {
  return (
    <div>
      <h1>Вход</h1>
      {/* Здесь позже будет форма */}
    </div>
  );
};